import { useMemo } from "react";
import { decimalFormatter } from "../../Utils/Formatter";

const useAircraftColumns = () => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "acft",
        header: "Aircraft",
      },
      ...[
        "total",
        "android",
        "ios",
        "win64",
        "linux",
        "macos",
        "switch",
        "android %",
        "ios %",
        "win64 %",
        "linux %",
        "macos %",
        "switch %",
      ].map((os) => ({
        accessorKey: os,
        header: os,
        size: 100,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue
            ? decimalFormatter.format(parseInt(renderedCellValue))
            : 0,
        muiTableHeadCellProps: {
          align: "right",
        },
        muiTableBodyCellProps: {
          align: "right",
        },
        muiTableFooterCellProps: {
          align: "right",
          fontWeight: 700,
        },
        Footer: ({ column, table }) => {
          if (column?.columnDef?.header?.includes("%")) return <></>;
          // Zugriff auf das komplette Datenset (alle Zeilen)
          const allData = table.options.data ?? [];

          // Summiere die Werte für diese Spalte über alle Datensätze
          const total = allData.reduce((acc, row) => {
            // row[column.id] => der Wert dieser Spalte in diesem Datensatz
            const val = row[column.id];
            return acc + (Number(val) || 0);
          }, 0);

          // Formatierung (z. B. Tausendertrennzeichen)
          return decimalFormatter.format(total);
        },
      })),
    ],
    []
  );

  return { columns };
};

export default useAircraftColumns;
